import { render, staticRenderFns } from "./StatisticObject.vue?vue&type=template&id=3a626961&scoped=true&"
import script from "./StatisticObject.vue?vue&type=script&lang=js&"
export * from "./StatisticObject.vue?vue&type=script&lang=js&"
import style0 from "./StatisticObject.vue?vue&type=style&index=0&id=3a626961&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a626961",
  null
  
)

export default component.exports